export const TRANSLATIONS = {
    es: {
        title: 'Resumen de evaluaciones',
        product: 'MAC FY26 — Ventas (Sales Audit)',
        print: 'Imprimir',
        auditsIncluded: 'Auditorías incluidas',
        excludedHint: n => `${n} excluidas · sin puntuación`,
        overallAvg: 'Promedio general',
        targetHint: n => `Objetivo ${n}%`,
        totalFindings: 'Incumplimientos totales',
        worstMonth: 'Peor mes',
        branchesAuditors: 'Sucursales · Auditores',
        activeInRange: 'Activos en el rango',
        from: 'Desde',
        to: 'Hasta',
        branches: 'Sucursales',
        auditors: 'Auditores',
        allBranches: 'Todas',
        allAuditors: 'Todos',
        target: 'Objetivo',
        average: 'Promedio',
        simpleMean: 'Media simple',
        weighted: 'Ponderado',
        apply: 'Aplicar filtros',
        cancel: 'Cancelar',
        excelToggleLead: 'También generar Excel',
        excelToggleRest:
            'Al aplicar los filtros el servidor devuelve un enlace .xlsx con las 4 tablas + KPIs, válido por 24 horas.',
        excelGenerated: 'Excel generado',
        downloadExcel: 'Descargar Excel',
        copyLink: 'Copiar enlace',
        linkCopied: 'Enlace copiado',
        excelShareHint:
            'El enlace es de lectura pública por 24 horas. No lo envíe fuera de su equipo si no es necesario.',
        excelFailed:
            'No se pudo generar el Excel. Aplica los filtros de nuevo o consulta al soporte.',
        empty:
            'No hay auditorías completadas en el rango seleccionado. Ajuste los filtros.',
        errorGeneric: 'Error al generar el reporte. Intente nuevamente.',
        loading: 'Generando reporte…',
        navTrend: 'Tendencia mensual',
        navAuditor: 'Por auditor',
        navBranch: 'Por sucursal',
        navFindingsMonth: 'Incumplimientos · mes',
        navFindingsAuditor: 'Incumplimientos · auditor',
        chartTitle: 'Tendencia del promedio mensual — Todos los auditores',
        chartDesc: (mode, target) =>
            `Promedio ${mode} por mes. Línea vertical = objetivo (${target}%). Colores por mes se explican en la leyenda al final.`,
        table1: 'Resumen de evaluaciones por auditor',
        table2: 'Resumen de evaluaciones por sucursal',
        table3: 'Acumulado de incumplimientos por mes',
        table4: 'Acumulado de incumplimientos por auditor',
        table4Info: 'Debe cuadrar con Tabla 3',
        auditor: 'Auditor',
        branch: 'Sucursal',
        process: 'Proceso',
        averageCol: 'Promedio',
        total: 'Total',
        overallAverage: 'Promedio general',
        auditorsMeta: (n, mode) => `${n} auditores · ${mode}`,
        branchesMeta: (n, mode) => `${n} sucursales · ${mode}`,
        findingsMeta: n => `${n} incumplimientos totales`,
        simpleMode: 'media simple',
        weightedMode: 'ponderado',
        recon: 'Reconciliación',
        legendOk: t => `≥ ${t}% (objetivo cumplido)`,
        legendAmber: (lo, hi) => `${lo} – ${hi}% (por debajo del objetivo)`,
        legendBad: t => `< ${t}% (crítico)`,
        legendBlank: '— sin auditorías',
        excelHowTitle: '¿Cómo funciona la descarga Excel?',
        excelHowBody:
            'Marque la casilla «También generar Excel» arriba y aplique los filtros. El servidor genera un archivo .xlsx con cinco hojas (KPI Resumen, Por auditor, Por sucursal, Incumplimientos · mes, Incumplimientos · auditor) y devuelve un enlace descargable.',
        excelHowHint:
            'Ver en pantalla es gratis y siempre disponible. La descarga Excel es opcional y bajo demanda — el enlace es válido por 24 horas y se puede compartir. Sin exportación de PDF.',
        generated: 'Generado',
        applied: 'Aplicados',
        audits: 'auditorías',
        allHistory: 'Todo el historial',
    },
    en: {
        title: 'Auditor Summary',
        product: 'MAC FY26 — Sales Audit',
        print: 'Print',
        auditsIncluded: 'Audits included',
        excludedHint: n => `${n} excluded · not scored`,
        overallAvg: 'Overall average',
        targetHint: n => `Target ${n}%`,
        totalFindings: 'Total findings (NC)',
        worstMonth: 'Worst month',
        branchesAuditors: 'Branches · Auditors',
        activeInRange: 'All active in range',
        from: 'From',
        to: 'To',
        branches: 'Branches',
        auditors: 'Auditors',
        allBranches: 'All',
        allAuditors: 'All',
        target: 'Target',
        average: 'Average',
        simpleMean: 'Simple mean',
        weighted: 'Weighted',
        apply: 'Apply filters',
        cancel: 'Cancel',
        excelToggleLead: 'Also generate Excel',
        excelToggleRest:
            'When checked, applying filters makes the server return a .xlsx download link (KPIs + 4 tables), valid for 24 hours.',
        excelGenerated: 'Excel generated',
        downloadExcel: 'Download Excel',
        copyLink: 'Copy link',
        linkCopied: 'Link copied',
        excelShareHint:
            'This signed URL is public-read for 24 hours. Do not share it outside your team unless needed.',
        excelFailed:
            'Excel could not be generated. Apply filters again or contact support.',
        empty: 'No completed audits in the selected range. Adjust the filters.',
        errorGeneric: 'Could not generate the report. Please try again.',
        loading: 'Generating report…',
        navTrend: 'Monthly trend',
        navAuditor: 'By auditor',
        navBranch: 'By branch',
        navFindingsMonth: 'Findings · month',
        navFindingsAuditor: 'Findings · auditor',
        chartTitle: 'Monthly average trend — All auditors',
        chartDesc: (mode, target) =>
            `${mode} per month. Vertical line = target (${target}%). Color coding matches the legend at the bottom.`,
        table1: 'Audit summary by auditor',
        table2: 'Audit summary by branch',
        table3: 'Cumulative findings by month',
        table4: 'Cumulative findings by auditor',
        table4Info: 'Must reconcile to Table 3',
        auditor: 'Auditor',
        branch: 'Branch',
        process: 'Process',
        averageCol: 'Average',
        total: 'Total',
        overallAverage: 'Overall average',
        auditorsMeta: (n, mode) => `${n} auditors · ${mode}`,
        branchesMeta: (n, mode) => `${n} branches · ${mode}`,
        findingsMeta: n => `${n} findings total`,
        simpleMode: 'simple mean',
        weightedMode: 'weighted',
        recon: 'Reconciliation',
        legendOk: t => `≥ ${t}% (target met)`,
        legendAmber: (lo, hi) => `${lo} – ${hi}% (below target)`,
        legendBad: t => `< ${t}% (critical)`,
        legendBlank: '— no audits in month',
        excelHowTitle: 'How the Excel download works',
        excelHowBody:
            'Tick the “Also generate downloadable Excel” checkbox above and click Apply filters. The server generates a .xlsx with five sheets (KPI Summary, By auditor, By branch, Findings · month, Findings · auditor) and returns a download link.',
        excelHowHint:
            'Viewing on screen is always free. Excel generation is opt-in — the link is valid for 24 hours and is shareable. No PDF export from this report.',
        generated: 'Generated',
        applied: 'Applied',
        audits: 'audits',
        allHistory: 'All history',
    },
}

export const getCopy = lang => TRANSLATIONS[lang] || TRANSLATIONS.es
